import React from "react";

import { IS_BROWSER } from "@config/consts";

import { Drawer } from "@ui/Molecules";

import { iOS } from "@services/iOS";

import { GenericPortal } from "@containers/GenericPortal";

import { DrawerManagerProvider } from "./DrawerManager.context";
import { useManager } from "./DrawerManager.hooks";
import { DrawerManagerComponentWWW } from "./DrawerManager.types";

export const DrawerManager: DrawerManagerComponentWWW = ({
  id,
  preventIOSKeyboardScroll,
  onClose,
  ...props
}) => {
  const drawer = useManager();
  const isActive = drawer.isDrawerActive(id);

  React.useEffect(() => {
    drawer.registerCloseHandler(id, () => {
      onClose?.();
    });
  }, [onClose]);

  // fix for iOS issue (DEV-311)
  // https://blog.opendigerati.com/the-eccentric-ways-of-ios-safari-with-the-keyboard-b5aa3f34228d
  React.useEffect(() => {
    if (!IS_BROWSER) return;
    if (!preventIOSKeyboardScroll) return;
    if (!iOS()) return;

    const scrollHandler = (event: Event): void => {
      const target = event.currentTarget as Window;
      const { scrollY } = target;

      // for a moment scrollY can be "0"
      if (scrollY !== 0) {
        target.removeEventListener("scroll", scrollHandler);

        window.scrollTo(0, 0);
      }
    };

    const cleanListener = () =>
      window.removeEventListener("scroll", scrollHandler);

    if (isActive) {
      window.addEventListener("scroll", scrollHandler);
      setTimeout(cleanListener, 500);
    } else {
      cleanListener;
    }

    return cleanListener;
  }, [preventIOSKeyboardScroll, isActive]);

  return (
    <GenericPortal.Portal type="drawer">
      {isActive && (
        <Drawer onRequestClose={drawer.hideDrawer.bind(null, id)} {...props} />
      )}
    </GenericPortal.Portal>
  );
};

DrawerManager.Provider = DrawerManagerProvider;
DrawerManager.useManager = useManager;
